import { useIsAuthenticated } from "@azure/msal-react";
import React from "react";
//redux
import { useDispatch } from "react-redux";
const AuthSSO = props => {
  const dispatch = useDispatch();
  const isAuthenticated = useIsAuthenticated();
  //   useEffect(() => {
  //     dispatch(changePreloader(true));
  //   }, []);

  return (
    <React.Fragment>
      {/* {isAuthenticated} */}
      <div id="preloader">
        <div id="status">
          <div className="spinner-chase">
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AuthSSO;
